/* naturallumi — shared interactions (Shopify) */
(function(){
  'use strict';

  var money = window.LL && window.LL.moneyFormat ? window.LL.moneyFormat : '${{amount}}';
  function formatMoney(cents){
    var value = (cents/100);
    return money.replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2))
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toString())
                .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.toFixed(2).replace('.', ','));
  }
  if(window.LL){ window.LL.format = formatMoney; }

  /* ---------- Sticky header over hero ---------- */
  var head = document.querySelector('.site-head--over');
  if(head){
    var hero = document.querySelector('[data-hero]');
    var sentinel = function(){
      var trigger = hero ? hero.offsetHeight - 90 : window.innerHeight*0.8;
      if(window.scrollY > trigger){ head.classList.add('is-solid'); }
      else { head.classList.remove('is-solid'); }
    };
    window.addEventListener('scroll', sentinel, {passive:true});
    sentinel();
  }

  /* ---------- Reveal on scroll ---------- */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('[data-reveal]').forEach(function(el,i){
      el.style.transitionDelay = (Math.min(i%4,3)*0.08)+'s';
      io.observe(el);
    });
  }

  /* ---------- Mobile drawer ---------- */
  var burgers = document.querySelectorAll('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  if(drawer){
    burgers.forEach(function(b){
      b.addEventListener('click', function(){ drawer.classList.toggle('open'); document.body.classList.toggle('no-scroll'); });
    });
    drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ drawer.classList.remove('open'); document.body.classList.remove('no-scroll'); }); });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  function openCart(){ if(cartDrawer){ cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); document.body.classList.add('no-scroll'); } }
  function closeCart(){ if(cartDrawer){ cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  document.querySelectorAll('[data-cart-open]').forEach(function(el){
    el.addEventListener('click', function(e){ if(cartDrawer){ e.preventDefault(); openCart(); } });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function(el){ el.addEventListener('click', closeCart); });
  if(cartOverlay){ cartOverlay.addEventListener('click', closeCart); }
  document.addEventListener('keyup', function(e){ if(e.key==='Escape'){ closeCart(); closeSearch(); } });

  /* ---------- Update cart count badges ---------- */
  function paintCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; });
  }

  /* ---------- Render cart drawer contents ---------- */
  function renderDrawer(cart){
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if(!body) return;
    paintCount(cart.item_count);
    if(cart.item_count === 0){
      body.innerHTML = '<div class="cart-drawer__empty flow"><p class="eyebrow">Empty</p><p class="lede">Your cart is quiet for now.</p><a href="/collections/all" class="btn btn--solid" data-cart-close>Discover the harvest</a></div>';
      if(foot) foot.style.display = 'none';
      body.querySelectorAll('[data-cart-close]').forEach(function(el){ el.addEventListener('click', closeCart); });
      return;
    }
    if(foot) foot.style.display = '';
    var html = cart.items.map(function(it){
      var img = it.image ? '<img src="'+it.image.replace(/(\.[^.]+)$/, '_160x$1')+'" alt="'+it.product_title+'">' : '';
      var variant = (it.product_has_only_default_variant ? '' : it.variant_title) || '';
      return '<div class="mini-line">'+
        '<a href="'+it.url+'" class="ph ph--celadon mini-line__media">'+img+'</a>'+
        '<div><div class="mini-line__name">'+it.product_title+'</div>'+
        (variant?'<div class="mini-line__var">'+variant+'</div>':'')+
        '<div class="qty" style="margin-top:10px"><button data-line-dec="'+it.key+'">–</button><span>'+it.quantity+'</span><button data-line-inc="'+it.key+'">+</button></div>'+
        '<button class="mini-line__rm" data-line-remove="'+it.key+'">Remove</button></div>'+
        '<div class="mini-line__price">'+formatMoney(it.final_line_price)+'</div>'+
      '</div>';
    }).join('');
    body.innerHTML = html;
    if(foot){
      var subEl = foot.querySelector('[data-cart-subtotal]');
      if(subEl) subEl.textContent = formatMoney(cart.total_price);
      var bar = foot.querySelector('[data-cart-progress]');
      var msg = foot.querySelector('[data-cart-ship-msg]');
      var threshold = window.LL && window.LL.freeShip ? window.LL.freeShip : 0;
      if(bar && threshold){
        var pct = Math.min(1, cart.total_price/threshold);
        bar.style.transform = 'scaleX('+pct+')';
        var left = threshold - cart.total_price;
        msg.innerHTML = cart.total_price>=threshold ? "You've earned <b>complimentary shipping</b>." : '<b>'+formatMoney(left)+'</b> away from complimentary shipping.';
      }
    }
    bindDrawerLines();
  }

  function bindDrawerLines(){
    document.querySelectorAll('[data-line-remove]').forEach(function(b){ b.onclick = function(){ changeLine(b.getAttribute('data-line-remove'), 0); }; });
    document.querySelectorAll('[data-line-inc]').forEach(function(b){ b.onclick = function(){ adjustLine(b.getAttribute('data-line-inc'), 1); }; });
    document.querySelectorAll('[data-line-dec]').forEach(function(b){ b.onclick = function(){ adjustLine(b.getAttribute('data-line-dec'), -1); }; });
  }
  function adjustLine(key, delta){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var it = cart.items.filter(function(i){return i.key===key;})[0];
      if(it) changeLine(key, Math.max(0, it.quantity+delta));
    });
  }
  function changeLine(key, qty){
    fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();}).then(function(cart){
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:cart}));
    });
  }
  window.llRefreshCart = function(){ fetch('/cart.js').then(function(r){return r.json();}).then(renderDrawer); };

  /* ---------- Add to cart (AJAX) ---------- */
  function bindAddForms(){
    document.querySelectorAll('form[action$="/cart/add"], form[data-add-form]').forEach(function(form){
      if(form.__bound) return; form.__bound = true;
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var orig = btn ? btn.innerHTML : '';
        if(btn){ btn.setAttribute('disabled','disabled'); btn.innerHTML = 'Adding…'; }
        fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: new FormData(form) })
          .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
          .then(function(res){
            if(btn){ btn.removeAttribute('disabled'); btn.innerHTML = orig; }
            if(!res.ok){ showToast(res.d.description || 'Could not add to cart'); return; }
            window.llRefreshCart();
            openCart();
            document.dispatchEvent(new CustomEvent('cart:added', {detail:res.d}));
          })
          .catch(function(){ if(btn){ btn.removeAttribute('disabled'); btn.innerHTML = orig; } });
      });
    });
  }
  bindAddForms();

  /* ---------- Toast ---------- */
  var toast = document.querySelector('[data-toast]');
  var toastTimer;
  function showToast(msg){
    if(!toast) return;
    if(msg){ toast.childNodes[0].nodeValue = msg + ' '; }
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toast.classList.remove('show'); }, 3200);
  }
  window.llToast = showToast;

  /* ---------- Predictive search ---------- */
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = searchPanel ? searchPanel.querySelector('input[type=search]') : null;
  var searchResults = searchPanel ? searchPanel.querySelector('[data-search-results]') : null;
  function openSearch(){ if(searchPanel){ searchPanel.classList.add('open'); document.body.classList.add('no-scroll'); if(searchInput) searchInput.focus(); } }
  function closeSearch(){ if(searchPanel){ searchPanel.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  document.querySelectorAll('[data-search-open]').forEach(function(el){ el.addEventListener('click', function(e){ if(searchPanel){ e.preventDefault(); openSearch(); } }); });
  document.querySelectorAll('[data-search-close]').forEach(function(el){ el.addEventListener('click', closeSearch); });
  var searchTimer;
  if(searchInput){
    searchInput.addEventListener('input', function(){
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if(q.length < 2){ searchResults.innerHTML=''; return; }
      searchTimer = setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function(r){return r.json();})
          .then(function(data){
            var products = (data.resources.results.products)||[];
            if(!products.length){ searchResults.innerHTML = '<p class="body">No teas match "'+q+'" yet.</p>'; return; }
            searchResults.innerHTML = '<div class="prod-grid cols-4">'+products.map(function(p){
              var img = p.featured_image && p.featured_image.url ? '<img src="'+p.featured_image.url+'" alt="'+p.title+'">' : '';
              return '<a href="'+p.url+'" class="card"><div class="ph ph--celadon card__media">'+img+'</div><div class="card__name" style="font-size:1.2rem">'+p.title+'</div><div class="card__price" style="font-size:1rem;margin-top:6px">'+p.price+'</div></a>';
            }).join('')+'</div>';
          });
      }, 220);
    });
  }
  window.llCloseSearch = closeSearch;

  // initial paint
  window.llRefreshCart();
})();
